import React from "react";

const CancelIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="shrink-0"
    {...props}
  >
    <mask
      id="mask0_1364_2042"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1364_2042)">
      <circle cx="9.5" cy="9.83398" r="7.5" fill="white" />
      <path
        d="M9.66634 10.834L12.083 13.2507C12.2358 13.4034 12.4302 13.4798 12.6663 13.4798C12.9025 13.4798 13.0969 13.4034 13.2497 13.2507C13.4025 13.0979 13.4788 12.9034 13.4788 12.6673C13.4788 12.4312 13.4025 12.2368 13.2497 12.084L10.833 9.66732L13.2497 7.25065C13.4025 7.09787 13.4788 6.90343 13.4788 6.66732C13.4788 6.43121 13.4025 6.23676 13.2497 6.08398C13.0969 5.93121 12.9025 5.85482 12.6663 5.85482C12.4302 5.85482 12.2358 5.93121 12.083 6.08398L9.66634 8.50065L7.24967 6.08398C7.0969 5.93121 6.90245 5.85482 6.66634 5.85482C6.43023 5.85482 6.23579 5.93121 6.08301 6.08398C5.93023 6.23676 5.85384 6.43121 5.85384 6.66732C5.85384 6.90343 5.93023 7.09787 6.08301 7.25065L8.49967 9.66732L6.08301 12.084C5.93023 12.2368 5.85384 12.4312 5.85384 12.6673C5.85384 12.9034 5.93023 13.0979 6.08301 13.2507C6.23579 13.4034 6.43023 13.4798 6.66634 13.4798C6.90245 13.4798 7.0969 13.4034 7.24967 13.2507L9.66634 10.834ZM9.66634 18.0007C8.51356 18.0007 7.43023 17.7819 6.41634 17.3444C5.40245 16.9069 4.52051 16.3132 3.77051 15.5632C3.02051 14.8132 2.42676 13.9312 1.98926 12.9173C1.55176 11.9034 1.33301 10.8201 1.33301 9.66732C1.33301 8.51454 1.55176 7.43121 1.98926 6.41732C2.42676 5.40343 3.02051 4.52148 3.77051 3.77148C4.52051 3.02148 5.40245 2.42773 6.41634 1.99023C7.43023 1.55273 8.51356 1.33398 9.66634 1.33398C10.8191 1.33398 11.9025 1.55273 12.9163 1.99023C13.9302 2.42773 14.8122 3.02148 15.5622 3.77148C16.3122 4.52148 16.9059 5.40343 17.3434 6.41732C17.7809 7.43121 17.9997 8.51454 17.9997 9.66732C17.9997 10.8201 17.7809 11.9034 17.3434 12.9173C16.9059 13.9312 16.3122 14.8132 15.5622 15.5632C14.8122 16.3132 13.9302 16.9069 12.9163 17.3444C11.9025 17.7819 10.8191 18.0007 9.66634 18.0007Z"
        fill="#2D2D2D"
      />
    </g>
  </svg>
);

export default CancelIcon;
